import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'
import { errorColorFor } from '../shared/errorColor'

export type { ColorScheme }

const tokens = {
  dark: {
    bgInput: 'bg.input',
    textPrimary: 'text.primary',
    placeholder: 'text.secondary',
    borderSearch: 'border.search',
    borderHover: 'border.input-hover',
    focusRing: 'interactive.focus-ring',
  },
  light: {
    bgInput: 'light.bg.input',
    textPrimary: 'light.text.primary',
    placeholder: 'light.text.secondary',
    borderSearch: 'light.border.search',
    borderHover: 'light.border.input-hover',
    focusRing: 'light.interactive.focus-ring',
  },
}

export const containerStyles = (
  colorScheme: ColorScheme,
  isActive: boolean,
  showWarning: boolean,
  height: string,
  width: string | number,
  bgColor?: string,
  disabled = false
): SystemStyleObject => {
  const t = tokens[colorScheme]
  return {
    bg: bgColor ?? t.bgInput,
    border: '1px solid',
    borderColor: isActive ? t.focusRing : t.borderSearch,
    borderRadius: '0px',
    cursor: disabled ? 'not-allowed' : undefined,
    display: 'flex',
    flexDirection: 'column',
    height,
    justifyContent: showWarning ? 'flex-end' : 'center',
    overflow: 'hidden',
    opacity: disabled ? 0.5 : 1,
    position: 'relative',
    px: '10px',
    py: '4px',
    transition: 'border-color 0.15s ease',
    width,
    _hover: disabled
      ? undefined
      : {
          borderColor: isActive ? t.focusRing : t.borderHover,
        },
  }
}

export const counterTextStyles = (
  colorScheme: ColorScheme
): SystemStyleObject => ({
  color: errorColorFor(colorScheme),
  flexShrink: 0,
  fontSize: '11px',
  userSelect: 'none',
  whiteSpace: 'nowrap',
})

export const warningTextStyles = (
  colorScheme: ColorScheme
): SystemStyleObject => ({
  color: errorColorFor(colorScheme),
  fontSize: '8px',
  fontWeight: '600',
  letterSpacing: '0.08em',
  left: '10px',
  lineHeight: 1,
  position: 'absolute',
  textTransform: 'uppercase',
  top: '4px',
})

export const inputRowStyles: SystemStyleObject = {
  alignItems: 'center',
  display: 'flex',
  gap: '4px',
  position: 'relative',
}

export const actionButtonWrapperStyles: SystemStyleObject = {
  position: 'absolute',
  right: '10px',
  top: '50%',
  transform: 'translateY(-50%)',
}

export const inputStyles = (
  colorScheme: ColorScheme,
  disabled = false
): SystemStyleObject => ({
  bg: 'transparent',
  border: 'none',
  color: tokens[colorScheme].textPrimary,
  cursor: disabled ? 'not-allowed' : undefined,
  flex: 1,
  textStyle: 'small-body',
  height: '16px',
  margin: '0',
  minWidth: '0',
  outline: 'none',
  padding: '0',
  _placeholder: { color: tokens[colorScheme].placeholder },
})
